import { JFSRequest, executeRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const kycGetUploadId = (tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.getKycUploadId,
    method: 'POST',
    config: sitConfig(tokens),
    body: {},
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

const kycUploadDocument: any = (
  file: File,
  documentCategory: string,
  documentNumber: string,
  documentName: string,
  dateOfExpiry: string,
  uploadType: string,
  uploadId: string,
  tokens: any,
  identificationNumber: string,
  documentType,
) => {
  const reqBody = new FormData()
  reqBody.append('file', file)
  reqBody.append('uploadId', uploadId)
  reqBody.append('documentCategory', documentCategory)
  reqBody.append('documentNumber', documentNumber)
  reqBody.append('documentName', documentName)
  reqBody.append('dateOfExpiry', dateOfExpiry)
  reqBody.append('uploadType', uploadType)
  reqBody.append('documentType', documentType ? documentType : '')

  if (uploadType === 'SUBGROUP' || uploadType === 'ENTITY') {
    reqBody.append('identificationNumber', '')
  }
  if (uploadType === 'REDACT' && identificationNumber?.length > 0) {
    reqBody.append('identificationNumber', identificationNumber)
  }
  const config = {
    ...sitConfig(tokens),
    headers: {
      ...sitConfig(tokens).headers,
      'Content-Type': 'multipart/form-data',
      formData: true,
      parseReqBody: true,
    },
  }
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.kycUpload,
    method: 'POST',
    config: config,
    body: reqBody,
  }
  return executeRequest(request).then((response) => {
    return responseParser(response)
  })
  // return axios.post(`${BASE_URL}${APIEndPoints.kycUpload}`, reqBody, config).then((response) => {
  //   return responseParser(response)
  // })
}

export { kycGetUploadId, kycUploadDocument }
